<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { defineEmits, defineProps } from "vue";
import { ICzinResponse } from "@/types/calculators";
import ResultStack from "@/views/Calculators/ICzinPrediction/components/ResultStack.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";

const { t } = useI18n();

defineEmits(["reset"]);
defineProps<{
  results: number[];
  prediction: ICzinResponse;
}>();
</script>

<template>
  <div class="flex flex-col text-brown">
    <ResultStack :results="results" class="mb-10" />
    <h2 class="text-2xl font-semibold mb-4">
      {{ prediction.hexagram }}
    </h2>

    <div class="font-bold text-base leading-[20px] mb-4">
      {{ prediction.image }}
    </div>

    <div class="font-normal text-base leading-[20px] mb-4">
      {{ prediction.main_text }}
    </div>

    <ul class="mb-10 font-normal text-base leading-[20px] list-none">
      <li v-for="(val, key) in prediction.details" :key="key">
        <span class="font-bold"
          >{{ t("calculators.iczin.hexagram." + key) }}:</span
        >
        {{ val }}
      </li>
    </ul>

    <GradientButton
      class="mx-auto w-[223px] min-h-14"
      bg-color="bg-brown-gradient"
      hover-bg-color="bg-orange-gradient"
      :text="t('calculators.iczin.repeat-prediction-btn')"
      @click="$emit('reset')"
    />
  </div>
</template>
